import { firestoreAction } from 'vuexfire'
import db from '../firebase'

const state = {
  classes: [],
  classesFetched: false,
  ProtokollsFetched: false,
  filesFetched: false,
  APsFetched: false,
  files:[],
  Protokoll:[],
}
const getters = {
  APs: (state) => {
    return state.files
  },
  classes: (state) => {
    return state.classes
  },
  Protokoll: (state) => {
    return state.Protokoll
  },
  classesFetched: (state) => {
    return state.classesFetched
  },
  classesnameandId: (state) => {
    return state.classes.map(classes => [classes.name, classes.id])
  },
  APsFetched: (state) => {
    return state.APsFetched
  },
  ProtokollsFetched: (state) => {
    return state.ProtokollsFetched
  },
}
const mutations={
  logout_classesAP(state){
    state.classes=[];
    state.classesFetched=false;
    state.Protokoll=[];
    state.ProtokollsFetched=false;
    state.APsFetched=false;
    state.files=[];
    state.filesFetched=false;
    // // (state.files)
      }
}
const actions = {

  logoutclassesAP ({commit}) {
    commit('logout_classesAP')
    // this.$router.replace('login')
},

initProtokolls: firestoreAction(({ bindFirestoreRef,state  }, SchoolId) => {
  bindFirestoreRef('Protokoll', db.collection('files').where('schoolId', '==', SchoolId).where('type', '==', 'Protokoll')).then((res) => {
    state.ProtokollsFetched=true;
    // (state.files)
  })
}),

initAPs: firestoreAction(({ bindFirestoreRef,state  }, SchoolId) => {
  bindFirestoreRef('files', db.collection('files').where('schoolId', '==', SchoolId).where('type', '==', 'Åtgärdsprogram')).then((res) => {
    state.APsFetched=true;
    // (state.files)
  })
}),
initAPsforMe({state,dispatch },data){
  
  let APs=[];//SkolID och lärarId
  if(data.hasOwnProperty('classes')){
    
  let classIDs= data.classes.map(d=> d.id)
  //Hämtar alla lärare till klassen
  
  db.collection('files').where('schoolId', '==', data.schoolId).where('accessType', '==','teacher').where("class","in", classIDs).get().then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              const id = doc.id
              const output = doc.data()
              output.id=id;
              APs.push(output)
            })
            // state.APsFetched=true;
     state.files= APs
          }).then(()=>{
            //Hämtar alla mentorer till klassen
             db.collection('files').where('schoolId', '==', data.schoolId).where('accessType', '==','mentor').where("class", "in",  classIDs).get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        //  ("Find mentor")
        const id = doc.id
        const output = doc.data()
        const Class= data.classes.find(clas => clas.id ==output.class)
        if(Class != undefined)
        if (Class.mentorIds.includes(data.id)) {
          
          output.id=id;
          APs.push(output)
        }       
      })
       state.filesFetched=true;
      // 
     state.files= APs
    })
          })
          .then(()=>{
            //Hämtar alla lärare o mentorer till klassen
            db.collection('files').where('schoolId', '==', data.schoolId).where('accessType', '==','all').where("class","in", classIDs).get().then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                //  ("Find all")
                const id = doc.id
                const output = doc.data()
                output.id=id;
                APs.push(output)
              })
            })
          })
         
  }
              //Hämtar  lärarenom den finns med i klassens speclista
              db.collection('files').where('schoolId', '==', data.schoolId).where('accessType', '==','all').where("specAccess",  'array-contains', data.id).get().then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                //   ("Find spec in all")
                  const output = doc.data()
                  const id = doc.id
                  if (data.hasOwnProperty('classes')) 
                  {
                 if (data.classes.find(clas => clas.id ==output.class)==undefined) 
                 {
                   dispatch('findClass', output.class);
                 }
                }
                 else{
                  dispatch('findClass', output.class);
                 }
                  output.id=id;
                  APs.push(output)
                })
                //  (APs)
                state.APsFetched=true;
                state.files= APs
              }).then(()=>{
                       
                       //Hämtar  lärarenom den finns med i klassens speclista
                       db.collection('files').where('schoolId', '==', data.schoolId).where('accessType', '==','spec').where("specAccess",  'array-contains', data.id).get().then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                  
                //   ("Find spec")
                  const output = doc.data()
                  const id = doc.id
                  if (data.hasOwnProperty('classes')) 
                  {
                  if (data.classes.find(clas => clas.id ==output.class)==undefined) 
                  {
                    dispatch('findClass', output.class);
                  }
                }
                  else{
                   dispatch('findClass', output.class);
                  }
                  output.id=id;
                  APs.push(output)
                })
                //  (APs)
                state.APsFetched=true;
                state.files= APs
              })
                    })
   
    },
findClass({state},classId){
  //  (classId)
  db.collection('classes').doc(classId).get().then((doc) => {
      // const id = doc.id
      const output = doc.data()
      output.id=classId;
      if(state.classes.find(clas => clas.id ==classId)==undefined) 
      {    state.classes.push(output)
      //  ("added extra class")
    }
    })
  },
  removeAP({},APId){
    db.collection('files').doc(APId).delete()
  },
  saveAP({},AP){
    AP.uploadDate=  Date.now() 
    db.collection('files').doc(AP.id).update(AP)
  },
  createAP({},AP){
    
    AP.uploadDate=  Date.now() 
    db.collection('files').add(
      AP
    );
      },

//Classes

initClasses: firestoreAction(({ bindFirestoreRef,state  }, SchoolId) => {
  bindFirestoreRef('classes', db.collection('classes').where('schoolId', '==', SchoolId)).then((res) => {
    state.classesFetched=true;
  })
}),
initClassesforMe({state},data){
  let classes=[];//SkolID och lärarId
  db.collection('classes').where('schoolId', '==', data.schoolId).where("teacherIds", 'array-contains', data.id).get().then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
              const id = doc.id
              const output = doc.data()
              output.id=id;
              classes.push(output)
            })
          }).then(()=>{
            db.collection('classes').where('schoolId', '==', data.schoolId).where("mentorIds", 'array-contains', data.id).get().then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                const id = doc.id
                const output = doc.data()
                output.id=id;
                classes.push(output)
              })
              // //console.log(classes)
              state.classesFetched=true;
              state.classes= classes
            })
          })
          // .then(()=>{
          //   db.collection('classes').where('schoolId', '==', data.schoolId).where("mentorIds", 'array-contains', data.id).get().then(function (querySnapshot) {
          //     querySnapshot.forEach(function (doc) {
          //       const id = doc.id
          //       const output = doc.data()
          //       output.id=id;
          //       classes.push(output)
          //     })
          //     // (classes)
          //     state.classesFetched=true;
          //     state.classes= classes
          //   })
          // });
         
    },
  getClass({state},Class){
    //  (Class)
    //  (state.classes )
    //  (state.classes.find(Each => Each.id ==Class) )

     return state.classes.find(Each => Each.id ==Class) 
    },
removeClass({},ClassId){
  db.collection('classes').doc(ClassId).delete()
},
saveClass({},Class){
  db.collection('classes').doc(Class.id).update(Class)
},
createClass({},Class){
  Class.createdDate=  Date.now() 
  db.collection('classes').add(
    Class
  );
    },
 
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
